import React, { FC } from 'react';
import { PageTitle } from '../../layout/core';
import { salesAgenciesBreadCrumbs } from './CommissionsPage';
import { useTranslation } from 'react-i18next';
import { Deals } from '../../components/agents/Deals';

export const DealsPage: FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<PageTitle breadcrumbs={salesAgenciesBreadCrumbs}>{t('MENU.DEALS')}</PageTitle>
			<Deals/>
		</>
	);
};